import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class LeChat extends Component {
  render() {
    return (
      <div className="App-body-project">
        <h2>Le Chat</h2>
        <h3>Oct. - Dec. 2020</h3>
        <div className="App-body-project-video">
          <iframe title="Le Chat"
          src="https://player.vimeo.com/video/492507007" frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen></iframe>
        </div>
        <h4>Introduction</h4>
        <p>To better understand the entire animation process, I worked on a
          short animation from scratch together with Sarah Bawabe, Jiaju Ma, and
          Andrew Peterson. Our story follows an inquisitive cat who interacts
          with a computer AI (thus, the name Le Chat). I worked on modeling the
          office furniture (desk, computer monitor, and office chair), shading
          and lighting the office set, and animating the cat's walk cycle in
          Maya 2020.
        </p>
        <h4>Features</h4>
        <p>1. Modeling & Shading<br />
          2. Lighting<br />
          3. Walk Cycle<br /><br />
        </p>
        <h4>Modeling & Shading</h4>
        <p>I worked on modeling the background objects in the office scene
          (computer monitor, desk, and chair), including the UVs. I used
          reference images found online to get the proportions right before
          scaling the models to the scene.<br /><br />
          I also worked on most of the shaders for my group, first starting
          with a more realistic shading approach before we changed aesthetic
          directions to more predominantly diffuse shading for a more cartoony
          look.
        </p>
        <h4>Lighting</h4>
        <p>I helped work on the lighting aesthetics for the office set. We went
          with a cooler aesthetic (e.g., the blue walls) to contrast with Scene
          2's vibrant maze set. The lighting is mostly motivated by the ceiling
          light in the middle of the room, as well as a fill light from the
          window. The lighting could be further improved by refining it to still
          have some light behind the desk; we chose a lower emission value for
          the ceiling light as the room is relatively dark once the scientist
          exits. This, however, makes it hard to see the cat (we had to add a
          rim light when the cat walks behind the desk in Scene 1).
        </p>
        <h4>Walk Cycle</h4>
        <p>For the cat walk cycle, I followed several online tutorials. The walk
          cycle could be further refined by continuing to adjust the blend
          shapes and skinning of the rig, as the cat distorts when the
          front and back legs of the left/right side are close together. In
          addition, adding controls to the rig for the ankles would make the
          contact points less awkward, as the ankles maintain their sharp angle
          throughout the entire walk cycle. We tried to minimize these visual
          distortions in our short through careful usage of camera angles.
        </p>
        <h4>Reflection</h4>
        <p>Overall, I had a lot of fun working on this short together with my
          teammates. It was fun to see what unique background experience and
          skills my teammates had that ended up being useful, from Photoshop to
          2D animation and music composition. I also got the opportunity to play
          part of the background music in the first scene (violin).
        </p>
        <div className="App-body-project-buttons">
          <Link to="/pathtracer">
            <button type="button">
              &#8249; Previous: Path Tracer
            </button>
          </Link>
          <Link to="/work">
            <button type="button">
              Back to Portfolio
            </button>
          </Link>
          <Link to="/teapot">
            <button type="button">
              Next: Teapot &#8250;
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default LeChat;
